import React, { useState } from "react";
import { t } from "app/utils";

const Cap = ({ event, rsvp }) => {
  const [initialRSVPValue] = useState(rsvp);
  const { cap, acceptedCount } = event;
  let remaining = cap - acceptedCount;

  // if the initial rsvp value is equal to the new one, it does not have to update anything
  // because the event already has the right value, but if it is different, we need to update
  // the value locally for the component
  if (initialRSVPValue.responseType !== rsvp.responseType) {
    if (rsvp.responseType === "accepted") {
      remaining -= 1;
    } else {
      remaining += 1;
    }
  }

  let message;

  if (remaining < 1) {
    message = t("No Spots Remaining");
  } else {
    message = t(`${remaining} Spots Remaining`);
  }

  return <span>{message}</span>;
};

export default Cap;
